import pencil from 'assets/icons/pencil.svg'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from '../AllStyle.module.scss'

const ManningTableInfo = () => {
  const { t } = useTranslation('common')
  const [change, setChange] = useState(false)
  return (
    <div className={styles.wrapper}>
      <div style={{ width: '100%', height: '100%' }}>
        {change ? (
          <div className={styles.Design_true}>
            <div className={styles.DesignHeader}>
              <div className={styles.header_left}>
                <h4 className={styles.header_left_info}>{t('profile.manningTable.title')}</h4>
              </div>
              <div className={styles.headerRight}></div>
            </div>

            <div className={styles.Design_change_block}>
              <div className={styles.Design_change_header}>
                <div className={styles.headerLeft}>
                  <p className={styles.header_text}>{t('profile.manningTable.subdivision')}</p>
                  <input
                    type="text"
                    className={styles.Design_info_Header_inp}
                  />
                </div>
              </div>

              <ul className={styles.Design_desc}>
                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('profile.manningTable.position')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('profile.manningTable.category')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('profile.manningTable.payment_form')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('profile.manningTable.units_count')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                  />
                </li>
                <div className={styles.change_btn}>
                  <button className={styles.change_btn_add}>
                    <p style={{ color: 'white' }}>{t('profile.manningTable.add_more')}</p>
                  </button>
                </div>
              </ul>
              <ul className={styles.Design_desc_footer}>
                <li className={styles.Design_list_footer}>
                  <p className={styles.Design_info_footer}>{t('profile.manningTable.add_staff')}</p>
                  <input
                    type="text"
                    placeholder={t('profile.manningTable.order_number')}
                    className={styles.Design_info_change_inp}
                  />
                  <input
                    type="date"
                    className={styles.Design_info_change_inp}
                  />
                </li>

                <li className={styles.Design_list_footer}>
                  <p className={styles.Design_info_footer}>{t('profile.manningTable.remove_staff')}</p>
                  <input
                    type="text"
                    placeholder={t('profile.manningTable.order_number')}
                    className={styles.Design_info_change_inp}
                  />
                  <input
                    type="date"
                    className={styles.Design_info_change_inp}
                  />
                </li>
              </ul>

              <div className={styles.change_btn}>
                <button
                  onClick={() => setChange(false)}
                  className={styles.change_btn_Cancel}
                >
                  <p>{t('common.cancel')}</p>
                </button>
                <button className={styles.change_btn_save}>
                  <p style={{ color: 'white' }}>{t('profile.save_changes')}</p>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.Design}>
            <div className={styles.DesignHeader}>
              <div className={styles.header_left}>
                <h4 className={styles.header_left_info}>{t('profile.manningTable.title')}</h4>
              </div>
              <div className={styles.headerRight}>
                <img
                  src={pencil}
                  onClick={() => setChange(true)}
                  className={styles.headerRight_info}
                />
              </div>
            </div>

            <p
              style={{
                color: 'white',
                width: '80%',
                textAlign: 'left',
                margin: 'auto',
                marginLeft: '8%',
                marginTop: '15px',
              }}
            >
              {t('profile.manningTable.subdivision')}{' '}
            </p>
            <p
              style={{
                color: 'white',
                width: '80%',
                textAlign: 'left',
                margin: 'auto',
                marginLeft: '8%',
                marginTop: '15px',
              }}
            >
              {t('profile.manningTable.orpo_sample')}{' '}
            </p>
            <ul className={styles.Design_desc}>
              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.manningTable.position')}</p>
                <p className={styles.Design_info}>{t('profile.manningTable.engineer_programmer_sample')}</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.manningTable.category')}</p>
                <p className={styles.Design_info}>-</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.manningTable.payment_form')}</p>
                <p className={styles.Design_info}>{t('profile.manningTable.contract_sample')}</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.manningTable.units_count')}</p>
                <p className={styles.Design_info}>-</p>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default ManningTableInfo
